module.exports = __webpack_public_path__ + "img/course_004.788ad45.png";